export const AvatarCatalog = {
  eyes: {
    grin: "skin/expression/eyes/grinEye",
    heart: "skin/expression/eyes/heartEye",
    sideEye: "skin/expression/eyes/sideEye",
    deadPan: "skin/expression/eyes/deadPan",
    cringe: "skin/expression/eyes/cringe",
  },
  mouth: {
    closed: "skin/expression/mouth/closed mouth",
    grin: "skin/expression/mouth/grinMouth",
  },
  blush: {
    basic: "skin/expression/blush",
  },
  hair: {
    basic: "skin/hair/hair",
  },
  clothing: {
    hoodie: {
      shirt: "skin/clothing/top/shirt",
      shirt2: "skin/clothing/top/shirt",
      shirt3: "skin/clothing/top/shirt",
    },
    skirt: {
      skirt: "skin/clothing/bottom/skirt/skirt",
    },
    pants: {
      pant: "skin/clothing/bottom/pant/pant",
      pant2: "skin/clothing/bottom/pant/pant",
    },
  },
  effects: {
    embarrassed: "skin/expression/embarrassed",
    exclamation: "skin/expression/exmalation",
    explosion: "skin/expression/explotion",
  },
  accessories: {
    button: "skin/accessories/button",
    buttonSplash: "skin/accessories/button splash",
    chat1: "skin/accessories/chat1",
    chat2: "skin/accessories/chat2",
  },
};
